import React from 'react';
import LinkShape from './components/link-shape';
import { Container, Line } from './style';
import { color } from 'styles/settings';
import { LinkType } from 'graphql/types';
import { LinkSettings } from 'types';

const defaultColor = color.brand.greenDark;

export interface LinkRepresentationProps {
  settings?: LinkSettings;
}

const defaultProps = {};

function LinkRepresentation({ settings }: LinkRepresentationProps) {
  const { startShape, endShape, linkType } = settings || {};

  const color = settings?.color || defaultColor;

  return (
    <Container>
      {startShape && <LinkShape color={color} type={startShape} start />}
      <Line color={color} dashed={linkType === LinkType.Dashed} />
      {endShape && <LinkShape color={color} type={endShape} end />}
    </Container>
  );
}

LinkRepresentation.defaultProps = defaultProps;

export default LinkRepresentation;
